import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/data/siteData";

export default function ProcessSection() {
  return (
    <section data-testid="process-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">Notre méthode</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#00367e] leading-[1.1]">
            4 étapes pour une cuisine <span className="dh-underline">conforme</span>
          </h2>
          <p className="mt-5 text-lg text-slate-700">
            Un protocole précis, traçable et conforme aux normes en vigueur, mené par des techniciens experts en dégraissage CHR.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS_STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="relative bg-white rounded-3xl p-7 border border-slate-100 shadow-[0_8px_30px_rgb(0,54,126,0.06)]"
            >
              <div className="dh-num text-6xl text-[#00367e]/15 leading-none mb-2">{s.n}</div>
              <h3 className="text-xl font-bold text-[#00367e]">{s.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">{s.desc}</p>
              {i < PROCESS_STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-[#066ec4]/40" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
